if (!customElements.get('bottom-drawer')) {
	class BottomDrawer extends HTMLElement {
		connectedCallback() {
			this.dialog = this.querySelector('.bottom-drawer__dialog');
			this.closeButton = this.querySelector('.bottom-drawer__close');
			this.opener = document.querySelector(`[aria-controls="${this.id}"]`);
			this.isTransitioning = false;

			this.boundHandleOverlayClick = this.handleOverlayClick.bind(this);
			this.boundHandleEscapeKey = this.handleEscapeKey.bind(this);
			this.boundShow = this.show.bind(this);
			this.boundCloseFromButton = () => this.close('x');

			this.addEventListener('click', this.boundHandleOverlayClick);
			this.dialog.addEventListener('cancel', this.boundHandleEscapeKey);
			this.closeButton.addEventListener('click', this.boundCloseFromButton);
			this.opener.addEventListener('click', this.boundShow);
		}

		disconnectedCallback() {
			this.removeEventListener('click', this.boundHandleOverlayClick);
			this.dialog.removeEventListener('cancel', this.boundHandleEscapeKey);
			this.closeButton.removeEventListener('click', this.boundCloseFromButton);
			this.opener.removeEventListener('click', this.boundShow);
		}

		show() {
			if (this.isTransitioning) return;

			document.body.classList.add('modal-show');
			this.opener.setAttribute('aria-expanded', 'true');
			this.hidden = false;
			this.dialog.showModal();
			this.isTransitioning = true;
			this.dialog.classList.add('open');
			this.dialog.addEventListener('transitionend', () => {
				this.isTransitioning = false
			}, { once: true });

			this.dispatchEvent(new CustomEvent("bottom-sheet-open", {
				bubbles: true,
				detail: {
					drawerType: "Desktop",
					trigger: "Button"
				}
			}));

			if (localStorage.getItem("drawer-slide-out-shown") === null) {
				localStorage.setItem("drawer-slide-out-shown", "true");
			}
		}

		close(method = 'unknown') {
			if (this.isTransitioning) return;
			
			this.isTransitioning = true;
			this.dialog.classList.remove('open');

			this.dialog.addEventListener('transitionend', () => {
				this.opener.setAttribute('aria-expanded', 'false');
				this.dialog.close();
				this.hidden = true;
				this.isTransitioning = false;
				document.body.classList.remove('modal-show');
				this.dispatchEvent(new CustomEvent('bottom-sheet-close', {
					bubbles: true,
					detail: {
						drawerType: 'Desktop',
						method
					}
				}));
			}, { once: true });
		}

		handleOverlayClick(event) {
			if (event.target !== this.dialog) return;
			this.close('overlay');
		}

		handleEscapeKey(event) {
			event.preventDefault();
			this.close('esc');
		}
	}

	customElements.define('bottom-drawer', BottomDrawer);
}